import React, { useEffect, useState } from 'react';
import StockV from './Stock.v';
import stockService from 'services/stock.service';
import { StockDTO } from 'models/stock';

function Stock() {
    const [list, setList] = useState<StockDTO[]>([]);
    const [isLoaded, setLoaded] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [currentKeyword, setCurrentKeyword] = useState('');

    useEffect(() => {
        getData();
    }, []);

    async function getData(keyword?: string) {
        try {
            setLoaded(false);
            setError(null);
            const res = await stockService.list({
                page: 1,
                rows: 1000,
                keyword: keyword || undefined
            });
            setList(res.content || []);
            setCurrentKeyword(keyword || '');
            setLoaded(true);
        } catch (e: any) {
            setError(e.message || '데이터 조회 실패');
            setLoaded(true);
        }
    }

    async function handleSave(item: StockDTO) {
        try {
            await stockService.save(item);
            alert('재고가 수정되었습니다.');
            await getData(currentKeyword); // 현재 검색 조건 유지
        } catch (e: any) {
            alert(e.message || '재고 수정 실패');
        }
    }

    function handleSearch(keyword: string) {
        getData(keyword);
    }

    function handleRefresh() {
        getData(currentKeyword); // 현재 검색 조건으로 새로고침
    }

    return (
        <StockV
            list={list}
            isLoaded={isLoaded}
            error={error}
            onRefresh={handleRefresh}
            onSave={handleSave}
            onSearch={handleSearch}
        />
    );
}

export default Stock;